<div class="main">
        <div class="header">
          {{'LOADTYPE.loadType' | translate}}
          <i class="material-icons" (click)="closeDialog();">clear</i>
        </div>
        <div class="section">
      
          <div class="left">
            <div class="form">
              <div class="input">
                {{'LOADTYPE.material' | translate}}  <input type="text" class="form-input" [(ngModel)]="loadType.name"/>
              </div>
      
            </div>
          </div>
          <div class="right">
            <div class="form">
              <div class="input">
                {{'LOADTYPE.dimension' | translate}}
                <input type="text" class="dimension" value="ft." disabled />
                <img class="dropdown-icon" src="assets/icon-dropdown.svg" alt="">
              </div>
              <div class="input units">
                L  <input type="text"   class="form-input unit-input" [(ngModel)]="loadType.others.l">
              </div>
              <div class="input units">
                B  <input type="text"  class="form-input unit-input" [(ngModel)]="loadType.others.b">
              </div>
              <div class="input units">
                H  <input type="text"  class="form-input unit-input" [(ngModel)]="loadType.others.h">
              </div>
            </div>
            <div class="submitButton">
              <div class="button" (click)="addMaterial();">
                {{'LOADTYPE.submit' | translate}}
              </div>
            </div>
          </div>
      
        </div>
      </div>
      